
export const GET_ADMIN_STATS = "GET_ADMIN_STATS"
export const GET_ADMIN_STATS_SUCCESS = "GET_ADMIN_STATS_SUCCESS"
export const GET_ADMIN_STATS_FAIL = "GET_ADMIN_STATS_FAIL"
